import * as actionType from "../actionType";
import Urls, { postRequest } from "../../common/urls";

/** Max customer keys kept to avoid unbounded Redux state (same pattern as cnc/sensor/hennig). */
const MAX_CUSTOMER_KEYS = 10;

function pruneByCustomerKey(obj, currentKey, maxKeys) {
  const keys = Object.keys(obj);
  if (keys.length <= maxKeys) return obj;
  const kept = [currentKey];
  for (const k of keys) {
    if (k !== currentKey && kept.length < maxKeys) kept.push(k);
  }
  const next = {};
  kept.forEach((k) => (next[k] = obj[k]));
  return next;
}

const initialState = {
  timeSavingList: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.timeSavingGetList: {
      const customerId = action.data.customerId;
      let _timeSavingList = { ...state.timeSavingList };
      _timeSavingList[customerId] = action.data.timeSavingData;
      _timeSavingList = pruneByCustomerKey(_timeSavingList, customerId, MAX_CUSTOMER_KEYS);
      return {
        ...state,
        timeSavingList: _timeSavingList,
      };
    }
    default:
      return state;
  }
};

export default reducer;
